var map = {
	"./croce_foto.png": 2950,
	"./croce_foto_composta_2.png": 9801,
	"./croce_home/croce foto-01.png": 6365,
	"./croce_home/linea blu in alto-01.png": 1602,
	"./croce_home/linea rosa in alto-01.png": 1634,
	"./croce_home/linea verde in alto-01.png": 6174,
	"./gruppo1.png": 5227,
	"./gruppo2.png": 1054,
	"./gruppo3.png": 8431,
	"./logo_header.png": 4242,
	"./logo_mobile.png": 9720,
	"./sfondo_1.jpg": 2501,
	"./sfondo_1_mobile.jpg": 749,
	"./sfondo_2.jpg": 7863,
	"./sfondo_2_mobile.jpg": 7247,
	"./tema1.png": 6155,
	"./tema2.png": 6130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;